// extracted by mini-css-extract-plugin
export var orderDetails = "_v1-2";
export var orderImage = "_v1-1";
export var orderMeta = "_v1-3";
export var orderSummary = "_v1-0";
export var rightArrow = "_v1-4";